/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect, useContext, useCallback } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  Text,
  Group,
  Space,
  SimpleGrid,
  Image,
  TextInput,
  Container,
  Paper,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { showNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons';
import { sendRequest } from '../../services/services';
import backButton from '../../image/backArrow.png';
import PrimaryButton from '../../components/GroupButton';
import AppContext from '../../components/Context/index';

const UserDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t, i18n } = useTranslation();
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const searchParams = new URLSearchParams(search);
  const PassId = searchParams.get('passId');

  const [isValid, setIsValid] = useState(true);
  const [isTouched, setIsTouched] = useState(false);

  // Virtual Keyboard Functions
  const selectedVas = JSON.parse(localStorage.getItem('selectedVas'));

  const [inputs, setInputs] = useState({});
  const [layout, setLayout] = useState('default');
  const [inputName, setInputName] = useState('default');
  const keyboard = useRef();
  const [buttonText, setButtonText] = useState('Arabic');
  const [ticketData, setTicketData] = useState({});

  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isNum(val) {
    return /^\d+$/.test(val);
  }

  const searchTicket = useCallback(() => {
    sendRequest(`parking/reservations-by-pass-id/${PassId}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data || []);
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  });

  useEffect(() => {
    searchTicket();
  }, []);

  const [dummyInput, setDummyInput] = useState('');
  const [dummycharInput, setDummyCharInput] = useState('');

  const validate = (val) => {
    if (inputName.type === 'email') {
      if (emailIsValid(val)) setIsValid(true);
      else setIsValid(false);
    }
    if (inputName.type === 'number') {
      if (isNum(val)) setIsValid(true);
      else setIsValid(false);
    }
  };

  const onInputChange = (numberInput) => {
    setDummyInput(numberInput);
  };
  const onCharChange = (charInput) => {
    setDummyCharInput(charInput);
  };

  const onChangeAll = (inputsValue) => {
    /**
     * Here we spread the inputs into a new object
     * If we modify the same object, react will not trigger a re-render
     */
    setInputs({ ...inputsValue });
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (buttonText === 'Arabic') {
      setButtonText('English');
    } else if (buttonText === 'English') {
      setButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    validate(inputVal);
    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });

    keyboard.current.setInput(inputVal);
  };

  const getInputValue = (inputValue) => inputs[inputValue] || '';

  const detailsPage = () => {
    navigate({
      pathname: '/addVas',
      search: createSearchParams({
        passId: PassId,
        name: getInputValue('firstName') || dummycharInput,
        mobile: getInputValue('mobile') || dummyInput,
      }).toString(),
    });
  };

  const goBack = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        passId: PassId,
        name: getInputValue('firstName') || dummycharInput,
        mobile: getInputValue('mobile') || dummyInput,
      }).toString(),
    });
  };

  return (
    <Container>
      <Box>
        <Center>
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('user.details.title.text')}
          </Title>
        </Center>
        <Container sx={{ backgroundColor: '#FFFFFF' }}>
          <Group>
            <Button
              onClick={goBack}
              color="blue"
              radius="md"
              size="xl"
              leftIcon={<Image src={backButton} width={35} height={20} />}
              px="xl"
            />
            <Paper shadow="sm" sx={{ width: '40%', marginLeft: 150 }} px="xl">
              <Stack spacing="xs">
                <Text weight={500}>
                  <Center>{t('user.details.service.text')}</Center>
                  {selectedVas.map((item) => (
                    <Center>
                      <Group>
                        {item?.vas_type_id === 2 ? (
                          <Title order={3}>{t('choose.service.trolly.title.text')}</Title>
                        ) : item?.vas_type_id === 3 ? (
                          <Title order={3}>{t('choose.service.shuttle.title.text')}</Title>
                        ) : item?.vas_type_id === 24 ? (
                          <Title order={3}>{t('choose.service.carwash.title.text')}</Title>
                        ) : item?.vas_type_id === 144 ? (
                          <Title order={3}>{t('choose.service.quickService.title.text')}</Title>
                        ) : null}

                        {item?.vas_sub_type_id === 6 ? (
                          <Title order={3}>{t('choose.service.subtype.normal.text')}</Title>
                        ) : item?.vas_sub_type_id === 7 ? (
                          <Title order={3}>{t('choose.service.subtype.normal.text')}</Title>
                        ) : item?.vas_sub_type_id === 10 ? (
                          <Title order={3}>{t('choose.service.subtype.big.text')}</Title>
                        ) : item?.vas_sub_type_id === 1 ? (
                          <Title order={3}>{t('choose.service.carwash.inside.text')}</Title>
                        ) : item?.vas_sub_type_id === 3 ? (
                          <Title order={3}>{t('choose.service.carwash.outside.text')}</Title>
                        ) : null}
                      </Group>
                    </Center>
                  ))}
                </Text>
              </Stack>
            </Paper>
          </Group>

          <Container sx={{ marginLeft: 70 }}>
            <SimpleGrid cols={2}>
              <div>
                {ticketData?.result?.guest_users === null &&
                ticketData?.result?.customers === null ? (
                  <TextInput
                    label={
                      <Text size="lg" weight={700}>
                        {t('user.details.name.label')}
                      </Text>
                    }
                    py="xs"
                    value={dummycharInput}
                    maxLength={24}
                    autoFocus
                    placeholder={t('user.details.name.label')}
                    onChange={onCharChange}
                    style={{ width: '80%' }}
                    onBlur={() => setIsTouched(true)}
                  />
                ) : (
                  <Box py="xl">
                    <Center py="xl">
                      <Group>
                        <Text size="lg" weight={500}>
                          {' '}
                          {t('user.details.name.label')}:
                        </Text>
                        <Text size="lg" weight={700}>
                          {ticketData?.result?.customers?.full_name ||
                            ticketData?.result?.guest_users?.first_name}
                        </Text>
                      </Group>
                    </Center>
                  </Box>
                )}
              </div>
              {isTouched && !isValid && (
                <p style={{ color: 'red' }}>{t('user.details.validation')}</p>
              )}
              <div>
                <div>
                  {ticketData?.result?.guest_users === null &&
                  ticketData?.result?.customers === null ? (
                    <TextInput
                      label={
                        <Text size="lg" weight={700}>
                          {t('user.details.mobile.label')}
                        </Text>
                      }
                      py="xs"
                      value={dummyInput}
                      onBlur={() => setIsTouched(true)}
                      inputPattern={/^\d+$/}
                      maxLength={10}
                      placeholder={t('user.details.mobile.label')}
                      onChange={onInputChange}
                      style={{ width: '80%' }}
                    />
                  ) : (
                    <Box py="xl">
                      <Center py="xl">
                        <Group>
                          <Text size="lg" weight={500}>
                            {' '}
                            {t('user.details.mobile.label')}:
                          </Text>
                          <Text size="lg" weight={700}>
                            {ticketData?.result?.customers?.mobile ||
                              ticketData?.result?.guest_users?.mobile}
                          </Text>
                        </Group>
                      </Center>
                    </Box>
                  )}
                </div>

                {isTouched && !isValid && (
                  <p style={{ color: 'red' }}>{t('user.details.validation')}</p>
                )}
              </div>
            </SimpleGrid>
          </Container>
        </Container>
        <Space h="xl" />
        {/* <Container>
          <Keyboard
            // eslint-disable-next-line no-return-assign
            keyboardRef={(r) => (keyboard.current = r)}
            inputName={inputName}
            layoutName={layoutName}
            maxLength={16}
            layout={{
              default: [
                'Q W E R T Y U I O P',
                'A S D F G H J K L',
                'Z X C V B N M',
                '1 2 3 4 5 6 7 8 9 0',
                '{shift} {bksp}',
              ],
              shift: [
                'ا ب ت ث ح خ د ذ ر ج',
                'ظ ط ض س ص ش ع ف غ ز',
                'ك ة ى ؤ ء ي و ه ن م ل ق',
                '۱ ۲ ۳ ٤ ٥ ٦ ٧ ۸ ۹ ۰',
                '{shift} {bksp}',
              ],
            }}
            display={{
              '{bksp}': '⌫',
              '{enter}': buttonText !== 'Arabic' ? 'يدخل' : 'Enter',
              '{shift}': buttonText !== 'Arabic' ? 'ENG' : 'عربي',
            }}
            onChangeAll={onChangeAll}
            onKeyPress={onKeyPress}
          />
        </Container> */}
        {ticketData?.result?.guest_users === null && ticketData?.result?.customers === null ? (
          <Group position="apart">
            <Box style={{ width: '500px' }}>
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onChange={onCharChange}
                onKeyPress={onKeyPress}
                layoutName={layout}
                maxLength={15}
                layout={{
                  default: [
                    'Q W E R T Y U',
                    'I O P A S D F',
                    'G H J K L Z X',
                    'X C V B N',
                    '{shift} M {bksp}',
                  ],
                  shift: [
                    'ا ب ت ث ح خ د ذ ر ج',
                    'ظ ط ض س ص ش ع ف غ ز',
                    'ك ة ى ؤ ء ي و ه ن م ل ق',
                    '{shift} أ {bksp}',
                  ],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': buttonText !== 'Arabic' ? 'إرسال' : 'Enter',
                  '{shift}': buttonText !== 'Arabic' ? 'ENG' : 'عربي',
                }}
              />
            </Box>
            <Box py="xl" style={{ width: '300px' }}>
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onChange={onInputChange}
                onKeyPress={onKeyPress}
                layoutName={layout}
                maxLength={12}
                layout={{
                  default: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                  shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': 'Enter',
                }}
              />
            </Box>
          </Group>
        ) : null}
      </Box>
      <Center p="xl">
        <Button size="lg" radius="xl" color="blue" style={{ width: '30%' }} onClick={detailsPage}>
          {t('user.details.submit.button.text')}
        </Button>
      </Center>

      <PrimaryButton />
      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
    </Container>
  );
};

export default UserDetails;
